export class DestinationProviderAttributes {
    'azure';
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "azure",
            "baseName": "azure",
            "type": "DestinationProviderAttributesAzure",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return DestinationProviderAttributes.attributeTypeMap;
    }
    constructor() {
    }
}
